export default __webpack_public_path__ + "static/media/close-icon.8879b584.svg";